/** @format */

import { useEffect, useState } from "react";
import type { Root } from "react-dom/client";
import { createRoot } from "react-dom/client";
import Toast from "../../core/toast/Toast";

let root: Root | null = null;

export const showErrorToast = (message: string) => {
  // Create or get the container
  let div = document.getElementById("errorToast");
  if (!div) {
    div = document.createElement("div");
    div.id = "errorToast";
    document.body.appendChild(div);
  }

  // Create or reuse root
  if (!root) {
    root = createRoot(div);
  }

  root.render(<ErrorToast key={Date.now()} message={message} />);
};

function ErrorToast({ message }: { message: string }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const showTimeout = setTimeout(() => {
      setShow(false);
    }, 10);

    const removeTimeout = setTimeout(() => {
      const div = document.getElementById("errorToast");
      if (div && root) {
        root.unmount();
        div.remove();
        root = null;
      }
    }, 5500);

    return () => {
      clearTimeout(showTimeout);
      clearTimeout(removeTimeout);
    };
  }, []);

  return (
    <div style={{ zIndex: 999999999999 }}>
      <Toast leadingIcon="alert-circle-fill" variant="critical" show={show}>
        {message}
      </Toast>
    </div>
  );
}
